module.exports = __webpack_public_path__ + "img/Frame 1049three-1.06aa71de.png";